export class User {
    _id: any
    registrationMail: string
    name: string
    first_client_date: string
    last_modify: string
    last_login: string
    last_create_client: string
    dataInfo: object
    paymentInfo: object
    staffId?: string
    roles?: string[]
    clientDeviceId: string
    clientId: string
    token: string
    expiresInSeconds: string
    availability: string
    numClient: number
    is_free: boolean
    appMobile: boolean
    deleteDate: number
    paymentFailure: Date
    gmoCardFlg: any
}



// WEBPACK FOOTER //
// ./src/models/user.ts